"use client";

import { usePathname } from "next/navigation";
import { Home, Hospital, CalendarDays, Headphones, User } from "lucide-react";
import Link from "next/link";
import { useI18n } from "@/i18n/I18nProvider";

const navItems = [
  { id: "home", labelKey: "Home", icon: Home, href: "/" },
  { id: "hospitals", labelKey: "Hospitals", icon: Hospital, href: "/hospitals" },
  { id: "bookings", labelKey: "Bookings", icon: CalendarDays, href: "/bookings" },
  { id: "concierge", labelKey: "Concierge", icon: Headphones, href: "/concierge" },
  { id: "me", labelKey: "Me", icon: User, href: "/me" },
];

export default function BottomNav() {
  const pathname = usePathname();
  const { t } = useI18n();

  const getActiveId = () => {
    if (pathname === "/") return "home";
    if (pathname.startsWith("/hospitals")) return "hospitals";
    if (pathname.startsWith("/bookings") || pathname.startsWith("/book")) return "bookings";
    if (pathname.startsWith("/concierge")) return "concierge";
    if (pathname.startsWith("/me")) return "me";
    return "";
  };

  const active = getActiveId();

  return (
    <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[430px] bg-white border-t border-gray-100 z-50">
      <div className="flex items-center justify-around pt-2 pb-[max(0.5rem,env(safe-area-inset-bottom))]">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = active === item.id;
          const filled = isActive && item.id === "home";
          return (
            <Link key={item.id} href={item.href}
              className={`flex flex-col items-center gap-[3px] px-2 min-w-[56px] rounded-lg transition-colors ${isActive ? "text-primary" : "text-text-dark/45"}`}
              aria-label={t(item.labelKey)} aria-current={isActive ? "page" : undefined}>
              <Icon
                size={23}
                strokeWidth={isActive ? 2.2 : 1.9}
                fill={filled ? "currentColor" : "none"}
              />
              <span className={`text-[11px] ${isActive ? "text-primary font-semibold" : "font-medium"}`}>{t(item.labelKey)}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
